export default __webpack_public_path__ + "static/media/ABBvoice_W_Lt.1ddb9519.woff";